// test646
(646 && 0);
